module.exports = __webpack_public_path__ + "img/mew-spaceman.ace0602c.png";